import { render, staticRenderFns } from "./toAcceptChallenges.vue?vue&type=template&id=1f0184e2&scoped=true"
import script from "./toAcceptChallenges.vue?vue&type=script&lang=js"
export * from "./toAcceptChallenges.vue?vue&type=script&lang=js"
import style0 from "./toAcceptChallenges.vue?vue&type=style&index=0&id=1f0184e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0184e2",
  null
  
)

export default component.exports